var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconHand(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 22,
    viewBox: "0 0 19 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.6816 4.39385C11.6816 3.59055 12.3328 2.93934 13.1361 2.93934C13.9394 2.93934 14.5906 3.59055 14.5906 4.39385V10.6967M11.6816 4.39385V2.45451C11.6816 1.65121 11.0304 1 10.2271 1C9.42375 1 8.77254 1.65121 8.77254 2.45451L8.77275 3.90902M11.6816 4.39385V9.72705M8.77275 3.90902C8.77241 3.106 8.12133 2.45513 7.31824 2.45513C6.51493 2.45513 5.86373 3.10634 5.86373 3.90964L5.86353 12.1148L4.29236 10.5387C3.603 9.84717 2.46746 9.91026 1.85844 10.6739C1.39244 11.2583 1.37957 12.0849 1.82715 12.6835L5.31767 17.1423C5.9855 17.9953 6.34836 19.3102 6.34836 20.3936M8.77275 3.90902V8.75738M15.5603 20.3936V19.2644C15.5603 18.7487 15.7685 18.2567 16.1083 17.8688C16.5011 17.4203 16.9924 16.7997 17.1786 16.3131C17.4996 15.4742 17.4996 14.4204 17.4996 12.313L17.5 10.8851L17.4996 6.3332C17.4996 5.5299 16.8484 4.87869 16.0451 4.87869C15.2418 4.87869 14.5906 5.5299 14.5906 6.3332",
    stroke: "#808080",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconHand);
export default __webpack_public_path__ + "static/media/icon-hand.c8a4f9a82e888ed534c5a2d121324d40.svg";
export { ForwardRef as ReactComponent };